module.exports = __webpack_public_path__ + "img/primary-save-outline.af97ae69.svg";